var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-0.000000,-0.000000) scale(0.377358) translate(-0.000000,-0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0",
      "transform": "matrix(1.7097210884094238, 0, 0, 1.7097210884094238, 0.25515100359916687, -0.07168401032686234)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1.7097210884094238, 0, 0, 1.7097210884094238, 0.25515100359916687, -0.07168401032686234)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier",
      "transform": "matrix(1.7097210884094238, 0, 0, 1.7097210884094238, 0.25515100359916687, -0.07168401032686234)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('circle', {
    staticStyle: {
      "fill": "rgb(50, 55, 59)"
    },
    attrs: {
      "cx": "148.5",
      "cy": "148.5",
      "r": "148.5"
    }
  })])])])])]), _c('path', {
    staticStyle: {
      "fill": "rgb(38, 44, 48)"
    },
    attrs: {
      "d": "M212.135,69.187L52.188,216.96l79.034,79.034c5.669,0.657,11.433,1.006,17.278,1.006 c80.191,0,145.525-63.566,148.39-143.058L212.135,69.187z"
    }
  }), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e67e22"
    },
    attrs: {
      "d": "M58.883,219.794h146.234c5.182,0,9.383-4.201,9.383-9.383V75.383c0-5.182-4.201-9.383-9.383-9.383 H58.883c-5.182,0-9.383,4.201-9.383,9.383V210.41C49.5,215.593,53.701,219.794,58.883,219.794z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#cc691f"
    },
    attrs: {
      "d": "M205.117,66h-56.45v153.793h56.45c5.182,0,9.383-4.201,9.383-9.383V75.383 C214.5,70.201,210.299,66,205.117,66z"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#ecf0f1"
    },
    attrs: {
      "x": "115.5",
      "y": "66",
      "width": "33",
      "height": "66"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffcf6d"
    },
    attrs: {
      "d": "M142.47,241.897h98.873c3.401,0,6.157-2.757,6.157-6.157v-85.961c0-3.401-2.757-6.157-6.157-6.157 H142.47c-3.401,0-6.157,2.757-6.157,6.157v85.961C136.312,239.14,139.069,241.897,142.47,241.897z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#f9b65f"
    },
    attrs: {
      "d": "M241.343,143.621h-92.676v98.276h92.676c3.401,0,6.157-2.757,6.157-6.157v-85.961 C247.5,146.378,244.743,143.621,241.343,143.621z"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#b85627"
    },
    attrs: {
      "x": "181.362",
      "y": "143.621",
      "width": "21.087",
      "height": "42.175"
    }
  })])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }